import { render, staticRenderFns } from "./RevenueGrowth.vue?vue&type=template&id=44ff58c4&scoped=true&"
import script from "./RevenueGrowth.vue?vue&type=script&lang=js&"
export * from "./RevenueGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff58c4",
  null
  
)

export default component.exports